// eslint-disable-next-line
// const template = [
// {
//     title: "",
//     image: require(""),
//     imdb: "",
// }
// ];

export const nowPlaying = [
  {
    title: "Halloween",
    image: "https://m.media-amazon.com/images/M/MV5BMzZiNTdiYTgtYjNkMS00MmJmLWEwZGQtNmY0NGJkMGE0YmYzXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt0077651/",
  },
  {
    title: "A Nightmare on Elm Street",
    image: "https://m.media-amazon.com/images/M/MV5BNTZmN2VlMWMtMTdlMi00NDBhLWIyODMtODEwMzM0ODMwMWYwXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt0087800/",
  },
];

export const toBeDetermined = [
  {
    title: "To Be Determined",
    image: require("./assets/to-be-determined.jpg"),
    imdb: "",
  },
  {
    title: "To Be Determined",
    image: require("../src/assets/to-be-determined.jpg"),
    imdb: "",
  },
];

// eslint-disable-next-line
export const comingSoon = [
  {
    title: "The Cat in the Hat",
    image: "https://m.media-amazon.com/images/M/MV5BZmJhNzk4OGMtOTlmNC00ODAxLWFkYjYtY2RhYWVmNDg5YmViXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt2321555/",
  },
  {
    title: "Gremlins",
    image: "https://m.media-amazon.com/images/M/MV5BYmMzMmIxNzYtYjk3OS00NjBiLTkxNDQtODU3ZDNjN2RiMTIxXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt0087363/",
  },
  {
    title: "The Cat in the Hat",
    image: "https://m.media-amazon.com/images/M/MV5BZmJhNzk4OGMtOTlmNC00ODAxLWFkYjYtY2RhYWVmNDg5YmViXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt2321555/",
  },
  {
    title: "To Be Determined",
    image: require("../src/assets/to-be-determined.jpg"),
    imdb: "",
  },
];

// eslint-disable-next-line
export const christmasWeekend = [
  {
    title: "Elf",
    image: "https://m.media-amazon.com/images/M/MV5BNDQ0ZWE2NzgtNGNhMC00MDIwLWI1MjUtYjYxZGRiM2UyYTQzXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt0319343/",
  },
  {
    title: "National Lampoon's Christmas Vacation",
    image: "https://m.media-amazon.com/images/M/MV5BZDgxYzI2YWItNmUyNS00ZWE4LWEzZDctYTk1M2VkYjhkOWVmXkEyXkFqcGc@._V1_.jpg",
    imdb: "https://www.imdb.com/title/tt0097958/",
  },
]
